import './sentry'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { BrowserRouter as Router } from 'react-router-dom'

import AuthProvider from './context/auth/auth'
import ModalProvider from './context/modal/modal'
import UsersProvider from './context/users/users'
import StepsProvider from './context/steps/StepsProvider'
import DataProvider from './context/dataProvider/DataProvider'
import ReportsProvider from './context/reports/reports'
import './index.css'
import LangProvider from './context/langProvider/langProvider'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { isLimitedModeRefusal } from './services/subscription/limitedModeError'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // `HasActiveSubscription` guards reads as well as writes, so an
      // unactivated account is refused by whole screens at once - and React
      // Query's default three retries turned every one of those refusals into
      // four blocked requests. The refusal is settled the moment it arrives;
      // asking again cannot change it. Every other failure - a network drop, a
      // 5xx, a different permission denial - keeps the default attempts.
      retry: (failureCount, error) =>
        !isLimitedModeRefusal(error) && failureCount < 3,
    },
  },
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <LangProvider>
        <AuthProvider>
          <DataProvider>
            <StepsProvider>
              <UsersProvider>
                <ReportsProvider>
                  <ModalProvider>
                    <Router>
                      <App />
                    </Router>
                  </ModalProvider>
                </ReportsProvider>
              </UsersProvider>
            </StepsProvider>
          </DataProvider>
        </AuthProvider>
      </LangProvider>
      {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools initialIsOpen={false} position='bottom-right' />
      )}
    </QueryClientProvider>
  </React.StrictMode>,
)
